import type { Extensions } from '@tiptap/core'
import type { ContextType } from '../types'
import type { EditorAdapter } from './adapter'
import { IssueRef } from '../extensions/issue-reference'
import { IssueSuggestion } from '../extensions/issue-suggestion'
import { MacroSuggestion, RedmineMacroBlock, RedmineMacroInline } from '../extensions/redmine-macro'
import { ResourceRef } from '../extensions/resource-ref'
import { UserMention } from '../extensions/user-mention'
import { WikiLink } from '../extensions/wiki-link'
import { rmDataSources } from '../utils/redmine'

export class IssueAdapter implements EditorAdapter {
  readonly attachmentsContainerSelector = '.attachments_fields'

  constructor(
    private readonly meta: HTMLElement,
    readonly context: Extract<ContextType, 'issue-description' | 'issue-notes'>,
    readonly textareaSelector: string,
  ) { }

  get previewUrl(): string | undefined {
    return this.meta.dataset.previewUrl || undefined
  }

  get uploadPath(): string {
    return document.querySelector<HTMLInputElement>('input.filedrop')
      ?.dataset
      .uploadPath ?? '/uploads.js'
  }

  get userMentionUrl(): string | null {
    return this.meta.dataset.userMentionUrl
      || rmDataSources()?.users
      || null
  }

  get issueSuggestionUrl(): string | null {
    return rmDataSources()?.issues || null
  }

  get wikiPageSuggestionUrl(): string | null {
    return null
  }

  get extensions(): Extensions {
    const exts: Extensions = [WikiLink, IssueRef, RedmineMacroInline, RedmineMacroBlock, ResourceRef, MacroSuggestion]
    if (this.issueSuggestionUrl)
      exts.push(IssueSuggestion.configure({ url: this.issueSuggestionUrl }))
    if (this.userMentionUrl && this.context === 'issue-notes')
      exts.push(UserMention.configure({ url: this.userMentionUrl }))
    return exts
  }
}
